var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isPermission && !_vm.validateIsH5()
    ? _c(
        "div",
        { staticClass: "permission-cookie" },
        [
          _c(
            "p",
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("message.cookiesTis")) + "\n    "
              ),
              _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      _vm.statementVisible = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("message.learnMore")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.permissionCookie }
                },
                [_vm._v(_vm._s(_vm.$t("btn.ok")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("agreement", {
            attrs: {
              visible: _vm.statementVisible,
              lang: _vm.$i18n.locale,
              type: "privacy"
            },
            on: { "visible-change": _vm.visibleChange }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b6a09c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b6a09c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/permissionCookie/Index.vue
// module id = null
// module chunks = 